import { render, staticRenderFns } from "./NIRRegistry.vue?vue&type=template&id=0de5ef2a&scoped=true&"
import script from "./NIRRegistry.vue?vue&type=script&lang=js&"
export * from "./NIRRegistry.vue?vue&type=script&lang=js&"
import style0 from "./NIRRegistry.vue?vue&type=style&index=0&id=0de5ef2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de5ef2a",
  null
  
)

export default component.exports